import { ElementsConfig } from "../../../types/types";

export const tocConfig: ElementsConfig = {
  "Total Organic Content": {
    unit: "wt.%",
    elements: [{ originalName: "weightPercentage", outputName: "TOC" }],
  },
};
